import React from "react";

import { FIELD_TYPE, tabKeys, TT_PHIEU_VTYT } from "types/enums";
import { DataFormField } from "types/models/input-field-type";

import { ColumnProps } from "../../../../../types/models";
import { Input, Select } from "antd";
import type { CollapseProps } from "antd";

import { Descriptions } from "antd";
import type { DescriptionsProps } from "antd";
import { ColumnsEdit } from "../../../../../types/models/column-table-edit";

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER } = FIELD_TYPE;

const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
//--------------------------------------------

//----------------------------------------------

const allColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 40,
    align: "center",
    isResizable: true,
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    width: 120,
    align: "left",
    fixed: "left",
    isResizable: true,
  },
  {
    title: "Chức vụ",
    key: "chucVu",
    show: true,
    dataIndex: "chucVu",
    width: 140,
    align: "left",
    isResizable: true,
    fixed: "left",
  },
  {
    title: "Mã nhân viên",
    key: "maNhanVien",
    show: true,
    dataIndex: "maNhanVien",
    width: 80,
    align: "left",
    isResizable: true,
    fixed: "left",
  },
  // {
  //   title: "Nhóm",
  //   key: "",
  //   show: true,
  //   dataIndex: "",
  //   width: 100,
  //   align: "left",
  // },
  {
    title: "Năm",
    key: "",
    show: true,
    disabledCheck: true,
    dataIndex: "nam",
    align: "center",
    className: "white",
   // isResizable: true,
  },
  {
    title: "Công chuẩn",
    key: "congChuan",
    show: true,
    dataIndex: "congChuan",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "Công đi làm",
    key: "congLam",
    show: true,
    dataIndex: "congLam",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "Nghỉ phép",
    key: "nghiPhep",
    show: true,
    dataIndex: "nghiPhep",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "Nghỉ bù",
    key: "nghiBu",
    show: true,
    dataIndex: "nghiBu",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "Nghỉ ốm công ty",
    key: "nghiOmCongTy",
    show: true,
    dataIndex: "nghiOmCongTy",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "Nghỉ chế độ",
    key: "nghiCheDo",
    show: true,
    dataIndex: "nghiCheDo",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "Nghỉ lễ",
    key: "nghiLe",
    show: true,
    dataIndex: "nghiLe",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "FHF Mental Health 2021",
    key: "fhf",
    show: true,
    dataIndex: "fhf",
    width: 60,
    align: "right",
    isResizable: true,
  },

  {
    title: "Nghỉ không lương",
    key: "nghiKhongLuong",
    show: true,
    dataIndex: "nghiKhongLuong",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "Nghỉ hưởng BHXH",
    key: "nghiHuongBaoHiemXaHoi",
    show: true,
    dataIndex: "nghiHuongBaoHiemXaHoi",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    className: "white",
    title: "Tổng công lương hưởng",
    key: "tongCongLuongHuong",
    show: true,
    dataIndex: "tongCongLuongHuong",
    width: 60,
    align: "right",
    fixed: "right",
    isResizable: true,
  },
];
const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Phòng",
    name: "idPhongBan",
    disable: false,
  },
  {
    type: INPUT,
    label: "Mã NV",
    name: "maNhanVien",
    disable: false,
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: false,
  },
  {
    type: COMBO_BOX,
    name: "thang",
    label: "Tháng",
    disable: false,
    options: listMonths,
    rules: [{ required: true, message: "Vui lòng chọn tháng" }],
  },
  {
    type: COMBO_BOX,
    name: "nam",
    label: "Năm",
    disable: false,
    options: listYears,
    rules: [{ required: true, message: "Vui lòng chọn năm" }],
  },
];
// const item: DescriptionsProps['item'] = [
//   {
//     key: '1',
//     label: 'UserName',
//     children: 'Zhou Maomao',
//   },
//   {
//     key: '2',
//     label: 'Telephone',
//     children: '1810000000',
//   },
//   {
//     key: '3',
//     label: 'Live',
//     children: 'Hangzhou, Zhejiang',
//   },
//   {
//     key: '4',
//     label: 'Remark',
//     children: 'empty',
//   },
//   {
//     key: '5',
//     label: 'Address',
//     children: 'No. 18, Wantang Road, Xihu District, Hangzhou, Zhejiang, China',
//   },
// ];

// const items: CollapseProps['items'] = [
//   {
//     key: '1',
//     label: 'Ký hiệu',
//     children: <Descriptions items={item} />
//   }

// ];

export { allColumns, itemsInputField, listYears };
